
import { Component, Vue, Model, Prop, Watch } from 'vue-property-decorator';

@Component
export default class StatusCard extends Vue {
  @Prop() readonly cardText!: {
    title: string;
    description: string[];
  };
  @Prop() readonly cardValue!: number;
  @Prop() readonly filledIcon!: string;
  @Prop() readonly halfIcon!: string;
  @Prop() readonly unFilledIcon!: string;
  @Prop() readonly activeItemExists!: boolean;
  @Model('setActive', { type: Boolean }) active!: boolean;

  valueChanged = 0;
  showIndicator = false;
  showX = true;
  cardClicked = false;
  mouseEntered = false;

  timer: number | undefined = undefined;
  indicatorDirection: 'up' | 'down' = 'up';
  get iconCounts() {
    let filled = 0;
    let half = 0;
    let unFilled = 0;

    if (this.cardValue % 1 === 0.5) {
      half = 1;
      filled = this.cardValue - 0.5;
    } else {
      filled = this.cardValue;
    }
    unFilled = 10 - filled - half;

    return {
      filled,
      half,
      unFilled,
    };
  }

  get cardActive(): boolean {
    return this.active;
  }

  set cardActive(newVal: boolean) {
    this.$emit('setActive', newVal);
  }

  setClickedCard() {
    this.showX = true;
    this.cardClicked = true;
    if (!this.activeItemExists) {
      this.cardActive = true;
    }
  }

  closeCard() {
    this.cardActive = false;
    this.cardClicked = false;
  }

  mouseEnter() {
    if (!this.cardClicked && !this.activeItemExists) {
      this.mouseEntered = true;
      setTimeout(() => {
        this.setActiveByMouse();
      }, 500);
    }
  }

  mouseLeave() {
    if (!this.cardClicked) {
      this.mouseEntered = false;
      this.cardActive = false;
      this.showX = true;
    }
  }

  setActiveByMouse() {
    if (this.mouseEntered && !this.cardActive) {
      this.showX = false;
      this.cardActive = true;
    }
  }

  @Watch('cardValue')
  setIndicator(newVal: number, oldVal: number) {
    // increment the value changed value
    this.valueChanged += 1;
    // clear any previous indicators from the screen
    clearTimeout(this.timer);
    this.showIndicator = false;

    if (newVal !== oldVal && this.valueChanged > 1) {
      this.showIndicator = true;
      this.timer = setTimeout(() => {
        this.showIndicator = false;
      }, 10000);
    }
    if (newVal > oldVal) {
      this.indicatorDirection = 'up';
    } else {
      this.indicatorDirection = 'down';
    }
  }
}
